module.exports = __webpack_public_path__ + "static/media/creativesHead.ef68a48a.jpg";